import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';

import { maskNumber } from '../../utils/maskMobileNum';
function* getCphDataResponse({ payload: { offset, limit, search, fromDate, toDate,agentId } }) {
  try {
    const response = yield call(axiosPrivate.get, `/cou-dashboard/customerpaymenthistory?page=${offset ? offset : 1}&limit=${limit ? limit : 100}${search ? `&search=${search}` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}${agentId ? `&agentId=${agentId}` : ""}`);
    yield put(actions.getCphDataSuccess(response?.data?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getCphDataFailed(error.response.data.message?error.response.data.message:error));
  }
}

function* getCphDetailDataResponse({ payload: { mobileNumber,offset, limit, search, fromDate, toDate,agentId } }) {
  try {
    const response = yield call( axiosPrivate.get, `/cou-dashboard/customerpaymenthistory/${mobileNumber}?page=${offset ? offset : 1}&limit=${limit ? limit : 100}${search ? `&search=${search}` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}${agentId ? `&agentId=${agentId}` : ""}` );
       {
         if (response?.data?.data) {
           response.data.data = response.data.data.map((item) => ({
             ...item,
             mobileNumber: maskNumber(item.mobileNumber),
             amount: item.amount / 100,
           }));
         }
       }
    yield put(actions.getCphDetailDataSuccess(response?.data?.data, response?.data?.total));
  } catch (error) {
    yield put(actions.getCphDetailDataFailed(error));
  }
}


export default function* rootSaga() {
  yield all([takeEvery(actions.GET_CPH_DATA, getCphDataResponse)]);
  yield all([takeEvery(actions.GET_CPHDETAIL_DATA, getCphDetailDataResponse)]);
}


